// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"b8018b51","86":"c95098db","384":"7a756a1c","549":"7d43c052","980":"61fffeba"}[chunkId] + ".chunk.css";
};